import { useCallback, useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { getShiftDuties, getAllStaffDuties } from "../features/shift/shiftSlice";
import { getAllStaffPermissions } from "../features/staff/staffSlice";
import AllShift from "../components/shift";
import { ShiftListToolbar } from "../components/shift/shift-screen-toolbar";
import LoadingSpinner from "../components/common/Loading";
import NoDataMessage from "../components/common/NoDataMessage";
import { Roles, initialDropdownValues } from "../utils/constants";
import { styles } from "../components/shift/styles";

const ShiftScreen = () => {
  const dispatch = useAppDispatch();
  const pharmacyID = Number(localStorage?.getItem("pharmacyId"));
  const [bubbleNumber, setBubbleNumber] = useState(0);
  const [filterValuesParents, setFilterValuesParent] = useState<{
    dropdown1: string | null;
    dropdown2: string | null;
    dropdown3: string | null;
    dropdown4: string | null;
    date: string | undefined;
  }>(initialDropdownValues);




  useEffect(() => {
    let inc = 0;
    Object.values(filterValuesParents).forEach((value) => {
      if (value) {
        inc++;
      }
    })
    setBubbleNumber(inc);
  }, [filterValuesParents])
  const [parentDropdownOptions, setDropDownValues] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const {
    isAddShiftDutySuccess,
    isAddShiftDutyLoading,
    isUpdateShiftDutyLoading,
    isDeleteShiftDutyLoading

  }: any = useAppSelector((state) => state.shift);
  const GetAllStaffPermissions = useCallback(() => {
    // dispatch(getAllStaffPermissions(15))
    // dispatch(getShiftDuties(15));
    // dispatch(getAllStaffDuties(15))
    dispatch(getAllStaffPermissions(pharmacyID))
    dispatch(getShiftDuties(pharmacyID));
    dispatch(getAllStaffDuties(pharmacyID))
  }, [dispatch]);

  useEffect(() => {
    if (pharmacyID) {
      GetAllStaffPermissions();
      setBubbleNumber(0);
      setFilterValuesParent(initialDropdownValues);
    }
  }, [pharmacyID, GetAllStaffPermissions, isAddShiftDutySuccess, isAddShiftDutyLoading, isDeleteShiftDutyLoading, isUpdateShiftDutyLoading]);
  const {
    staffPermissionsPayload,
    isStaffStatusLoading,
  }: any = useAppSelector((state) => state.staff);

  const {
    shiftDutiesPayload,
    shiftDutiesActivitiesPayload,
    isShiftDutiesLoading,
    isShiftDutiesActivitiesLoading

  }: any = useAppSelector((state) => state.shift);
  // Log the data properly
  const dutiesIDs = shiftDutiesPayload?.staff_duty_with_roles?.map((item: any) => item?.pharmacyStaff?.id);

  const staffMembers = Array.from(
    new Set(
      staffPermissionsPayload?.filter((item: any) => item?.credentials?.isActive)?.map((item: any) => `${item?.staff?.name}-${item?.staff?.id}`)
    )
  ).map((staffString: any) => {
    const [name, id] = staffString?.split("-");
    if (!dutiesIDs?.includes(String(id))) {
      return { name, id: Number(id) };
    }
  })?.filter((item: any) => item);
  const shiftTypes = ["Morning", "Evening", "Night"];
  const shiftStatus = ["Completed", "In Progress", "Absent", "Upcoming"];
  const uniqueRoles = Array.from(new Set(staffPermissionsPayload?.map((item: any) => String(item.credentials?.role))));
  const mappedRoles = uniqueRoles.map((role: any) => {
    const roleName = Roles[role];
    return roleName.charAt(0).toUpperCase() + roleName.slice(1).toLowerCase();
  });
  const dropdownOptionsMemo = useMemo(() => ({
    EmployeeName: Array.from(new Set(staffPermissionsPayload?.map((item: any) => item?.staff?.name))),
    Role: mappedRoles,
    ShiftType: shiftTypes,
    ShiftStatus: shiftStatus,
  }), [shiftDutiesPayload]);

  // Update dropdown values when shift list changes
  useEffect(() => {
    setDropDownValues(dropdownOptionsMemo);
  }, [dropdownOptionsMemo]);

  // Handle search query
  const handleSearch = useCallback((query: string) => {
    setSearchQuery(query);
  }, []);

  return (
    <>
      {/* <Box sx={styles.titleBox}>
        {(isShiftDutiesLoading || isStaffStatusLoading || isShiftDutiesActivitiesLoading) && <LoadingSpinner fullScreen />}
        List of Shift Members
      </Box> */}
      <Box sx={styles.containerBox}>
        <Box>
          <ShiftListToolbar
            setFilterValuesParent={setFilterValuesParent}
            dropDownOptions={parentDropdownOptions}
            employeeNames={staffMembers}
            onSearch={handleSearch}
            bubbleNumber={bubbleNumber}
          />
        </Box>

        <Box sx={styles.contentBox}>
          <br />
          {(shiftDutiesPayload?.staff_duty_with_roles?.length === 0 || shiftDutiesPayload === undefined) ? <NoDataMessage heightProp={"65vh"} /> :
            <AllShift
              searchQuery={searchQuery}
              requiredFilters={filterValuesParents} // Apply filters
              getAllShifts={GetAllStaffPermissions} // Fetch shifts again
              clinicId={String(pharmacyID)} // Pass pharmacy ID for filtering
              setDropDownValues={setDropDownValues} // Set new dropdown values
              employeeNames={staffMembers}
              apiData={shiftDutiesPayload}
              activityData={shiftDutiesActivitiesPayload}
              staffMembers={staffPermissionsPayload}
            />}
        </Box>

        {/* Shift Member Details */}

      </Box>
    </>
  );
};

export default ShiftScreen;
